/*!
 * slxControls v1.0.6 (http://selerix.com)
 * Copyright 2017 Selerix Systems, Inc. All Rights Reserved.
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 *
 * Dependencies: jQuery v1.10+, Bootstrap v3.2+, polyfills.js
 */
(function () {
	'use strict';
	var x = window.SlxControl;

	/*
	 * slx.nodeBar
	 * Dependencies: slx.core, slx.progressBar
	 */
	x.slx.nodeBar = function nodeBar(el) {
		var that = this;
		el.data('success', el.data('success') || 0);
		el.data('value', el.data('value') || 0);
		el.data('active', true);
		el.data('warning', el.data('warning') || 0);
		el.data('danger', el.data('danger') || 0);
		that.progressOrder = ['success', 'default', 'warning', 'danger'];
		that.overlays = false;

		x.slx.progressBar.apply(that, arguments);

		el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		that.nodesContainer = el.children('.slx-nodebar-nodes');

		var SlxNode = function SlxNode(n, index) {
			n = n || {};

			var self = this;
			self._element = null;
			self._index = index !== void 0 ? index : typeof (that.nodes) === 'function' ? that.nodes().length : that.nodes.length;
			self.title = null;
			self.url = null;
			self.theme = 'default';
			self.active = false;
			self.disabled = false;
			self.onClick = null;

			var _nodes = [], tempNodes = n.nodes;
			delete n.nodes;

			if (Array.isArray(tempNodes)) {
				for (var i = 0; i < tempNodes.length; i++) {
					_nodes.push(new SlxNode(tempNodes[i], i));
				}
			}

			x.extend(self, n);

			if (self.onClick !== null && typeof (self.onClick) !== 'function') { self.onClick = new Function(self.onClick); }

			self.add = function (n1, doRefresh) {
				var node = n1 instanceof SlxNode ? n1 : new SlxNode(n1);
				node._index = _nodes.length;
				_nodes.push(node);

				if (self._element === null) { return; }
				var c = self._element.children('.slx-nodebar-nodes');
				if (c.length === 0) { self._element.append(c = x('<DIV/>').addClass('slx-nodebar-nodes')); }

				_addToDOM(node, c);
				if (doRefresh === void 0 || doRefresh) { _refreshNodes(c); }
			};

			self.nodes = function (i) {
				if (i === void 0) { return _nodes; }
				if (typeof (i) === 'number') {
					if (_nodes.length <= i) { return null; }
					return _nodes[i];
				} else {
					//self.nodes.clear();
					if (i !== null) {
						if (Array.isArray(i)) { for (var j = 0; j < i.length; j++) { self.add(i[j]); } }
						else { self.add({}).add(i); }
					}
				}
			};

			//self.nodes.clear = function () {
			//	_nodes.length = 0;
			//	self._element.children('.slx-nodebar-nodes').find('.slx-nodebar-node').remove();
			//	for (var i = 0; i < that.progressBars.length; i++) { that.value(i, 0); }
			//};
		};

		var _nodes = [];
		if (Array.isArray(that.nodes)) {
			for (var i = 0; i < that.nodes.length; i++) {
				_nodes.push(new SlxNode(that.nodes[i]));
			}
		}
		delete that.nodes;

		that.add = function (n, doRefresh) {
			var node = n instanceof SlxNode ? n : new SlxNode(n);
			node._index = _nodes.length;
			_nodes.push(node);
			_addToDOM(node, that.nodesContainer);
			if (doRefresh === void 0 || doRefresh) { that.refresh(); }
			return that;
		};

		that.nodes = function (i) {
			if (i === void 0) { return _nodes; }
			if (typeof (i) === 'number') {
				if (_nodes.length <= i) { return null; }
				return _nodes[i];
			} else {
				that.nodes.clear();
				var tmp = Array.isArray(i) ? i : [i];
				for (var i = 0; i < tmp.length; i++) { _nodes.push(new SlxNode(tmp[i])); }

				var c = _nodeCount();
				for (var i = 0, j = 1, n = c < 2 ? 2 : c; i < n; i++, j++) {
					var node = that.nodes(i) || new SlxNode();
					if (_nodes.length < j) { that.add(node, false); }
					else { _addToDOM(node, that.nodesContainer); }

					var childLng = _nodeCount(node.nodes(), j), childContainer = null;
					if (childLng > 0) { node._element.append(childContainer = x('<DIV/>').addClass('slx-nodebar-nodes')); }

					for (var k = 0, m = 1; k < childLng; k++, m++) {
						var child = node.nodes(k) || new SlxNode();
						if (node.nodes(k) === null) { node.add(child, false); }
						else { _addToDOM(child, childContainer); }
						_refreshNodes(childContainer, false);
					}
				}
				that.refresh();
			}
		};

		that.nodes.clear = function () {
			_nodes.length = 0;
			that.nodesContainer.find('.slx-nodebar-node').remove();
			for (var i = 0; i < that.progressBars.length; i++) { that.value(i, 0); }
		};

		var _nodeCount = function (arr, j) {
			var i = 1;
			if (j === void 0) { j = ''; i = 0; }
			arr = arr || _nodes;

			var toInt = function (s) {
				if (!s.startsWith('node')) { return 0; }
				var p = s.split((i > 0 ? 'node' + j : '') + '_');
				return p.length > i ? parseInt(p[i].replace(/[^0-9\.]+/g, '')) || 0 : 0;
			};

			var d = Object.keys(el.data()).sort(function (k1, k2) {
				return toInt(k2) - toInt(k1);
			});
			var c = d.length ? toInt(d[0]) : 0;
			return c < arr.length ? arr.length : c;
		};

		that.refresh = function (c) { _refreshNodes(c || that.nodesContainer); };

		var _addToDOM = function (n, c) {
			n._element = x('<DIV/>').addClass('slx-nodebar-node').attr('data-theme', n.theme);
			var btn = x('<BUTTON/>').attr('type', 'button').addClass('btn');
			if (n.active) {
				if (n.theme === 'default') { btn.addClass('btn-primary'); }
				else { btn.addClass('btn-' + n.theme); }
				btn.addClass('active');
			}
			else { btn.addClass('btn-' + n.theme); }
			if (n.disabled) { btn.attr('disabled', 'disabled'); }
			if (typeof (n.onClick) === 'function') { btn.on('click.slx.node', n.onClick); }
			else if (n.url !== null) { btn.on('click.slx.node', function () { window.location = n.url; }); }
			if (that.tooltips) {
				btn.attr('data-toggle', 'tooltip').attr('data-placement', that.tooltipPlacement).attr('data-container', '#' + that.container.prop('id')).attr('title', n.title);
				btn.tooltip();
			}
			n._element.append(btn);
			c.append(n._element);
		};

		var _refreshNodes = function (c, refreshProgress) {
			if (refreshProgress == void 0) { refreshProgress = true; }
			var nodes = c.children('.slx-nodebar-node');
			var isChild = c.parent().closest('.slx-nodebar-nodes').length > 0;
			if (isChild) {
				nodes.css({ width: (100 / nodes.length) + '%' });
			} else {
				var w = nodes.length === 1 ? 100 : (100 / (nodes.length - 1));
				w = (w === 100 && nodes.length === 2) ? 'calc(100% - 20px)' : w + '%';
				nodes.css({ width: w });
				if (nodes.length > 1) { nodes.last().width(20); }
			}
			if (refreshProgress) { _refreshProgress(); }
		};

		var _refreshNode = function (n) {
			n._element.attr('data-theme', n.theme);
			var btn = n._element.children('.btn').removeClass().addClass('btn').addClass('btn-' + n.theme);
			if (n.active) {
				if (n.theme === 'default') { btn.addClass('btn-primary'); }
				else { btn.addClass('btn-' + n.theme); }
				btn.addClass('active');
			}
			else { btn.addClass('btn-' + n.theme); }
			btn.attr('disabled', n.disabled ? 'disabled' : null);
		};

		var _refreshProgress = function () {
			for (var i = 0; i < that.progressBars.length; i++) {
				var bar = that.progress(i), btn;

				if (bar.theme === 'default') { btn = el.find('.slx-nodebar-node[data-theme="' + bar.theme + '"] > .btn-primary').last(); }
				else { btn = el.find('.slx-nodebar-node[data-theme="' + bar.theme + '"]').last().children('.btn'); }
				if (btn.length === 0) { continue; }

				var p = btn.parent(), pp = p.closest('.slx-nodebar-nodes'), ppp = pp.parent().closest('.slx-nodebar-node');
				var m = parseInt(p.css('margin-left').replace(/[^0-9\.\-]+/g, '') || 0);
				m += parseInt(pp.css('margin-left').replace(/[^0-9\.\-]+/g, '') || 0);

				var v = btn.position().left + p.position().left + pp.position().left + m;
				if (ppp.length > 0) v += ppp.position().left;
				that.value(i, (v / el.outerWidth() * 100) - that.total(i));
			}
		};

		that.activeParent = function (i) {
			var current = _nodes.find(function (n) { return n.active; }) || null;
			if (i === void 0) { return current; }
			if (_nodes.length > i && current !== null) {
				current.active = false;
				_refreshNode(current);
				var child = current.nodes().find(function (c) { return c.active; }) || null;
				if (child !== null) {
					child.active = false;
					_refreshNode(child);
				}
				current = _nodes[i];
				current.active = true;
				current.disabled = false;
				_refreshNode(current);
				that.refresh(that.nodesContainer);
				return current;
			}
			return null;
		};
		that.activeChild = function (p, c) {
			var parent = that.activeParent(p);
			if (parent === null) { return null; }

			var child = parent.nodes().find(function (n) { return n.active; }) || null;
			if (c === void 0) { return child; }
			if (parent.nodes().length > c) {
				if (child !== null) {
					child.active = false;
					_refreshNode(child);
				}
				child = parent.nodes(c);
				child.active = true;
				_refreshNode(child);
				that.refresh(child._element.parent());
				return child;
			}
			return null;
		}

		that.next = function () {
			var parent = that.activeParent();
			if (parent === null) return null;

			var child = parent.nodes().find(function (n) { return n.active; }) || null;
			var nc = parent.nodes(child !== null ? child._index + 1 : parent.nodes().length + 1);
			if (nc != null) {
				child.active = false;
				child.theme = 'success';
				_refreshNode(child);

				nc.active = true;
				nc.disabled = false;
				_refreshNode(nc);
			} else {
				if (child !== null) {
					child.active = false;
					child.theme = 'success';
					_refreshNode(child);
				}
				parent.active = false;
				parent.theme = 'success';
				_refreshNode(parent);
				var n = _nodes.length > parent._index + 1 ? _nodes[parent._index + 1] : null;
				if (n !== null) {
					n.active = true;
					n.disabled = false;
					_refreshNode(n);
					var c = n.nodes(0);
					if (c !== null) {
						c.active = true;
						c.disabled = false;
						_refreshNode(c);
					}
				}
			}
			_refreshProgress();
		};

		/* initialization */
		(function () {
			if (!el.hasClass('slx-nodebar')) { el.addClass('slx-nodebar'); }
			if (!that.container.hasClass('slx-nodebar-container')) { that.container.addClass('slx-nodebar-container'); }
			if (that.nodesContainer.length === 0) {
				that.nodesContainer = x('<DIV/>').addClass('slx-nodebar-nodes');
				el.append(that.nodesContainer);
			}

			var c = _nodeCount();
			for (var i = 0, j = 1, n = c < 2 ? 2 : c; i < n; i++, j++) {
				var node = that.nodes(i) || new SlxNode();
				node._index = i;
				node.title = el.data('node' + j + '-title') || node.title;
				node.url = el.data('node' + j + '-url') || node.url;
				node.theme = el.data('node' + j + '-theme') || node.theme;
				node.active = el.data('node' + j + '-active') || node.active;
				node.disabled = el.data('node' + j + '-disabled') || node.disabled;
				node.onClick = el.data('node' + j + '-onclick') || node.onClick;
				if (node.onClick !== null && typeof (node.onClick) !== 'function') { node.onClick = new Function(node.onClick); }

				if (_nodes.length < j) { that.add(node, false); }
				else { _addToDOM(node, that.nodesContainer); }

				var childLng = _nodeCount(node.nodes(), j), childContainer = null;
				if (childLng > 0) { node._element.append(childContainer = x('<DIV/>').addClass('slx-nodebar-nodes')); }

				for (var k = 0, m = 1; k < childLng; k++, m++) {
					var child = node.nodes(k) || new SlxNode();
					child._index = k;
					child.title = el.data('node' + j + '_' + m + '-title') || child.title;
					child.url = el.data('node' + j + '_' + m + '-url') || child.url;
					child.theme = el.data('node' + j + '_' + m + '-theme') || child.theme;
					child.active = el.data('node' + j + '_' + m + '-active') || child.active;
					child.disabled = el.data('node' + j + '_' + m + '-disabled') || child.disabled;
					child.onClick = el.data('node' + j + '_' + m + '-onclick') || child.onClick;
					if (child.onClick !== null && typeof (child.onClick) !== 'function') { child.onClick = new Function(child.onClick); }

					if (node.nodes(k) === null) { node.add(child, false); }
					else { _addToDOM(child, childContainer); }
					_refreshNodes(childContainer, false);
				}
			}
			that.refresh();

			setTimeout(function () { el.trigger(x.Event('render')); }, 0);
		})();

		/* events */
		(function () {
			el.off('change.slx.nb').on('change.slx.nb', function (event) {
				if (that.onChange !== null && typeof (that.onChange) === 'function') { that.onChange(); }
			});
		})();

		el[0].slxNodeBar = this;

		return el;
	};
	x.slx.nodeBar.prototype = Object.create(x.slx.progressBar.prototype);
	x.slx.nodeBar.prototype.constructor = x.slx.nodeBar;

	/* jQuery extenders */
	x.fn.extend({
		slxNodeBar: function () {
			var slx = this.slxControl('slxNodeBar', arguments) || new x.slx.nodeBar(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof (slx[arg]) === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	x(function () { x('.slx-nodebar').each(function () { x(this).slxNodeBar(); }); });

	return x;
})();